import React from "react";
import ContactSubmissionsContainer from "../../modules/GAContactSubmissions/containers/ContactSubmissionsContainer/ContactSubmissionsContainer";

const GASalesContactSubmissions = () => {
  return <ContactSubmissionsContainer />;
};

export default GASalesContactSubmissions;
